import { render, staticRenderFns } from "./RegisterOrder.vue?vue&type=template&id=5e7f4b8e&scoped=true&"
import script from "./RegisterOrder.vue?vue&type=script&lang=ts&"
export * from "./RegisterOrder.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterOrder.vue?vue&type=style&index=0&id=5e7f4b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f4b8e",
  null
  
)

export default component.exports